(() => {
  const SELECTOR = '[data-track-component]';
  const visibleViewport = (component) => {
    const rails = Array.from(component.querySelectorAll('[data-lameda-rail]'));
    return rails.find((rail) => !rail.closest('[hidden]')) || rails[0] || null;
  };
  const update = (component) => {
    const viewport = visibleViewport(component);
    if (!viewport) return;
    const prev = component.querySelector('[data-lameda-rail-prev]');
    const next = component.querySelector('[data-lameda-rail-next]');
    const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const atStart = viewport.scrollLeft <= 3;
    const atEnd = viewport.scrollLeft >= max - 3;
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
    viewport.dataset.scrollState = atStart && atEnd ? 'static' : atStart ? 'end-more' : atEnd ? 'more-end' : 'more-more';
  };
  const step = (viewport) => {
    const item = viewport.querySelector('[data-lameda-rail-item]');
    if (!item) return viewport.clientWidth * .82;
    const track = viewport.querySelector('[data-lameda-rail-track]');
    const styles = getComputedStyle(track || viewport);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  };
  const init = (component) => {
    if (!component || component.dataset.lamedaRailReady === 'true') return;
    const rails = component.querySelectorAll('[data-lameda-rail]');
    if (!rails.length) return;
    component.dataset.lamedaRailReady = 'true';
    const prev = component.querySelector('[data-lameda-rail-prev]');
    const next = component.querySelector('[data-lameda-rail-next]');
    if (prev) prev.addEventListener('click', () => { const v = visibleViewport(component); if (v) v.scrollBy({left:-step(v),behavior:'smooth'}); });
    if (next) next.addEventListener('click', () => { const v = visibleViewport(component); if (v) v.scrollBy({left:step(v),behavior:'smooth'}); });
    rails.forEach((rail) => rail.addEventListener('scroll', () => update(component), {passive:true}));
    component.addEventListener('lameda:rail-change', () => requestAnimationFrame(() => update(component)));
    window.addEventListener('resize', () => update(component), {passive:true});
    requestAnimationFrame(() => update(component));
  };
  const boot = (root = document) => {
    if (root.matches && root.matches(SELECTOR)) init(root);
    root.querySelectorAll(SELECTOR).forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
